export default "__VITE_ASSET__SYlFJ57b__"